export function toFormParams(obj: object): URLSearchParams {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined || value === null) continue;
    params.append(key, String(value));
  }
  return params;
}
